import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import addSortFilterParams from 'root/src/client/logic/header/actions/addSortFilterParams'
import clearProjectArray from 'root/src/client/logic/header/actions/clearProjectArray'
import processSortFilter from 'root/src/client/util/processSortFilter'
import { TITLE_HEADER_MARKETPLACE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { getEndpointId } from 'root/src/client/logic/route/util/getEndpointIdFromModules'
import tabsFixedFilterSelector from 'root/src/client/logic/tab/selectors/fixedFilterSelector'
import allFieldsValuesSelector from 'root/src/client/logic/embedded/selectors/allFieldsValuesSelector'
import changeEmbeddedFieldData from 'root/src/client/logic/embedded/actions/changeEmbeddedFieldData'
import tabsFixedPayloadSelector from 'root/src/client/logic/tab/selectors/fixedPayloadSelector'
import map from 'ramda/src/map'
import keys from 'ramda/src/keys'
import addIndex from 'ramda/src/addIndex'
import values from 'ramda/src/values'
import pageItemLengthSelector from 'root/src/client/logic/list/selectors/pageItemLengthSelector'

export default sortFilters => (dispatch, getState) => {
	const state = getState()
	const moduleId = TITLE_HEADER_MARKETPLACE_MODULE_ID
	const endpointId = getEndpointId(state, moduleId)
	const sortFiltered = allFieldsValuesSelector(state,
		{ moduleId: TITLE_HEADER_MARKETPLACE_MODULE_ID })
	const tabsFixedFilter = tabsFixedFilterSelector(sortFiltered)
	const tabsFixedPayload = tabsFixedPayloadSelector(sortFiltered)
	const pageItemLength = pageItemLengthSelector(state, { moduleId })
	const payload = processSortFilter({
		sortFilters,
		startValue: {
			currentPage: 1,
			filter: tabsFixedFilter,
			sortType: undefined,
			...tabsFixedPayload,
			pageItemLength,
		},
	})
	addIndex(map)((field, idx) => dispatch(changeEmbeddedFieldData(['embedded', moduleId, 'fieldData', keys(sortFilters)[idx]], field)),
		values(sortFilters))

	dispatch(addSortFilterParams(moduleId, payload))
	dispatch(clearProjectArray())
	return dispatch(apiRequest(endpointId, payload))
}
